import React from 'react';
export function Footer() {
  return <footer className="bg-brand-text text-gray-400 py-12 px-4" data-id="element-99">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-100">
        <div className="inline-block bg-brand-primary text-white font-black px-4 py-1.5 rounded-full mb-6 text-sm tracking-widest uppercase" data-id="element-101">
          ⚡ MASTER ELECTROTÉCNICO
        </div>

        <p className="text-base font-medium mb-4 max-w-xl" data-id="element-102">
          El sistema definitivo para técnicos que quieren dominar la
          automatización, PLC y comandos industriales.
        </p>

        <p className="text-xs text-gray-500 mt-8" data-id="element-103">
          © 2026 Master Electrotécnico. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}